<template>
  <div
    class="sticky bottom-4 left-0 right-0 bg-green text-black shadow-lg z-50 p-3 w-[90%] rounded-3xl mx-auto"
  >
    <div class="w-full flex items-center justify-between gap-4">
      <div
        @click="goToCart"
        class="flex items-center gap-4 bg-green-dark rounded-3xl p-4 cursor-pointer flex-1 max-w-sm backdrop-blur-sm !h-[67px]"
      >
        <div class="flex items-center gap-3 text-white">
          <div class="relative">
            <button-element
              @on-action="goToCart"
              :label="''"
              :icon="'pi pi-shopping-cart '"
              :type="'button'"
              class="!h-[35px] !w-[35px] !rounded-lg [&_.pi-shopping-cart]:!text-green"
              :severity="'secondary'"
            ></button-element>
            <span
              v-if="totalItems > 0"
              :class="[
                'absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-[20px] h-[20px] flex justify-center items-center font-bold transition-all duration-300',
                countAnimated ? 'scale-125 animate-pulse' : '',
              ]"
              >{{ totalItems > 99 ? '99+' : totalItems }}</span
            >
          </div>

          <p
            :class="[
              'font-bold text-xl transition-all duration-300',
              priceAnimated ? 'scale-110' : '',
            ]"
          >
            {{ $userStore.isProfessional ? formatPrice(cartTotals.total_ht) : formatPrice(cartTotals.total_ttc) }} €
            <span class="text-sm opacity-90 ml-1 font-bold">{{
              $userStore.isProfessional ? 'HT' : 'TTC'
            }}</span>
          </p>
        </div>
      </div>

      <button-element
        @on-action="goToCart"
        :label="$userStore.isStorekeeper ? 'Mon retrait' : 'Ma commande'"
        :icon="''"
        :type="'button'"
        :severity="'secondary'"
        :class="['!h-[67px] !text-lg !text-green !px-[30px]']"
      ></button-element>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { formatPrice } from '@/services/globalFunctions'
import ButtonElement from '@/components/atoms/ButtonElement.vue'

import { useCart } from '@/services/useCart';
const { products, cartTotals, fetchCartTotals } = useCart();

import { useUsers } from '@/features/users/controller'
const $userStore = useUsers()

import { useOrders } from '@/features/orders/controller'
const $ordersStore = useOrders()

const router = useRouter()

const priceAnimated = ref(false)
const countAnimated = ref(false)
let priceTimeout: number | null = null
let countTimeout: number | null = null

const totalItems = computed(() => {
  if (!$ordersStore.activeOrder) return 0

  return (
    $ordersStore.activeOrder.products?.reduce((sum, item) => {
      // Ne pas compter les produits de livraison
      if (item.product?.category?.code === 'delivery') {
        return sum
      }

      // Nombre de big bags
      if (item.selectedBigBags?.length) {
        sum += item.selectedBigBags?.reduce((sumBags, bag) => sumBags + bag.quantity, 0)
      }

      // Produits en vrac (au volume) : compter 1 par ligne
      if (item.product?.sales_unit === 'volume') {
        return sum + 1
      }

      // Produits à l'unité et big bags : compter la quantité
      return sum + Number(item.quantity || 0)
    }, 0) || 0
  )
})

const goToCart = () => {
  router.push({ name: 'cart' })
}

watch(
  () => $ordersStore.activeOrder?.total_cost,
  (newPrice, oldPrice) => {
    if (newPrice !== oldPrice && oldPrice !== undefined) {
      // Animation du prix
      priceAnimated.value = true
      if (priceTimeout) clearTimeout(priceTimeout)
      priceTimeout = window.setTimeout(() => {
        priceAnimated.value = false
      }, 500)
    }
  },
)

watch(
  () => totalItems.value,
  (newCount, oldCount) => {
    if (newCount !== oldCount && oldCount !== undefined) {
      countAnimated.value = true
      if (countTimeout) clearTimeout(countTimeout)
      countTimeout = window.setTimeout(() => {
        countAnimated.value = false
      }, 500)
    }
  },
)

onMounted(() => {
  fetchCartTotals()
})
</script>
